<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.pdfRaport')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="picker noprint">
            <!-- datetimerange yyyy-MM-dd HH:mm:ss -->
            <el-date-picker
              type="daterange"
              v-model="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions1">
            </el-date-picker>
            <div class="btn btn-icon btn-info btn-search mar-rt-10 mar-lt-10" @click="getData"><i class="ti-search"></i></div>
            <button @click="print" class="btn btn-info btn-print">
              <img src="/static/img/icons/print-a4.png">
              {{$t('orders.print')}}
            </button>
            <button class="btn btn-info mar-lt-10 noprint btn-print" @click.prevent="printToIframe">
              <img src="/static/img/icons/print-a4.png">
              {{$t('orders.print2')}}
            </button>
            <div class="btn btn-icon btn-xls mar-lt-20" @click="downloadReport" :title="$t('reports.export')">
              {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="orders" v-if="orders">
            <div class="order card" v-for="order in orders">
              <div class="orderdet">
                <span style="text-align: center; width: 100%; margin-top: 20px;">{{order.number}} - {{order.id}} - {{order.token}}</span>
                <br>
                <p>
                  <span><b>Metoda:</b></span>
                  <span>{{order.delivery_type}}</span>
                </p>
                <p>
                  <span><b>Plata:</b></span>
                  <span>{{order.payment_type}}</span>
                </p>
              </div>

              <div class="client">
                <span><b>Client:</b></span>
                <span>{{order.delivery_details_firstname}}</span>
                <span>{{order.delivery_details_phone}}</span>
              </div>

              <div class="adress" v-if="order.address_shipping">
                <span><b>Adresa:</b></span>
                <span>{{order.address_shipping.state}}</span>
                <span>{{order.address_shipping.city}}</span>
                <span>{{order.address_shipping.street}} {{order.address_shipping.number}}, {{order.address_shipping.apartment}}</span>
              </div>

              <div class="date" v-if="order.pickup_datetime">
                <span><b>Data Livrare:</b></span>
                <span>{{order.pickup_datetime}}</span>
              </div>

              <div class="date" v-if="order.created_at">
                <span><b>Data Creare:</b></span>
                <span>{{order.created_at}}</span>
              </div>

              <div class="com" v-if="order.comments">
                <span><b>Comentarii:</b></span>
                <span>{{order.comments}}</span>
              </div>
              <div class="parts">
                <div class="part" v-for="part in order.parts">
                  <span v-if="order.order_type == 'GROUP'">
                    <span><b>Client:</b></span>
                    <span>{{part.customer_name}}</span>
                  </span>
                  <table class="table mar-to-25 mar-bt-15">
                    <thead>
                      <tr>
                        <th>Nume</th>
                        <th>Cantitate</th>
                        <th>Preț</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="prod in part.items" :key="prod.id">
                        <td>
                          <span>{{prod.name}}</span>
                          <div class="options">
                            <div class="option" v-for="option in prod.options" :key="option.id">
                              + <span>{{option.name}}</span>
                              <span v-if="option.price">{{option.price}} {{order.currency}}</span>
                            </div>
                            <template v-if="prod.additional_info">
                              - <span>{{prod.additional_info}}</span>
                            </template>
                          </div>
                        </td>
                        <td>{{prod.quantity}}</td>
                        <td>{{prod.price}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="total">
                <p>
                  <span>Subtotal:</span>
                  <span>{{order.totals_subtotals}} {{order.currency}}</span>
                </p>
                <p v-if="order.totals_extras">
                  <span>Extra:</span>
                  <span>{{order.totals_extras}} {{order.currency}}</span>
                </p>
                <p v-if="order.totals_shipping"><span>Livrare:</span> <span>{{order.totals_shipping}} {{order.currency}}</span></p>
                <p v-if="order.totals_discount">
                  <span>Reducere:</span>
                  <span>{{order.totals_discount}} {{order.currency}}</span>
                </p>
                <p>
                  <span>Total: </span>
                  <span>{{order.totals_grandtotal}} {{order.currency}}</span>
                </p>
              </div>
              <span></span>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="margin-bottom:200px">
          <h4>Produsele Comandate</h4>
          <div class="orders" v-for="product in products">
              <span class="product">{{product}}</span>
          </div>
        </div>
      </div>
    </div>
    <iframe id="print-frame" style="display:none;"></iframe>
  </div>
</template>

<script>
// import Vue from 'vue'
import {DatePicker} from 'element-ui'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import moment from 'moment'

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker
  },
  props: {
    isPdfRaport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPdfRaport () {
      if (this.isPdfRaport) {
        this.getData()
      }
    }
  },
  created () {
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.pdfRaportDeliveryOrders') + '_' + formattedDate + '.xlsx'
    // const currentDate = new Date()
    // const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    // this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls'
    // this.verifyUserLocations()
    // this.verifyUserMethods()
  },
  mounted () {
    if (document.getElementsByClassName('left-vertical-tabs')[0]) {
      document.getElementsByClassName('left-vertical-tabs')[0].classList.add('noprint')
    }
  },
  data () {
    return {
      loading: true,
      orders: null,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      date: [moment().format('YYYY-MM-DD'), moment().add(1, 'days').format('YYYY-MM-DD')],
      pickerNames: ['date_from', 'date_to'],
      pickerOptions1: {
        disabledDate (date) {
          // return date < moment().subtract(1, 'months')
          return date < moment().subtract(5, 'days')
        }
      },
      test1: '',
      products: [],
      export_file: '',
      export_name: ''
    }
  },
  methods: {
    printToIframe () {
      const iframe = document.getElementById('print-frame')
      const doc = iframe.contentWindow.document

      let ordersHtml = ''
      this.orders.forEach(order => {
        const partsHtml = order.parts.map(part => {
          const itemsHtml = part.items.map(prod => {
            const optionsHtml = prod.options && prod.options.length
              ? `<div class="options">${prod.options.map(opt =>
                  `+ ${opt.name}`
                ).join('<br>')}</div>`
              : ''
            const infoHtml = prod.additional_info
              ? `<div class="options">- ${prod.additional_info}</div>`
              : ''

            return `
              <tr>
                <td>
                  ${prod.name}
                  ${optionsHtml}
                  ${infoHtml}
                </td>
                <td class="center">${prod.quantity}</td>
              </tr>
            `
          }).join('')

          return `
            ${order.order_type === 'GROUP' ? `<div class="section"><b>Sub-client:</b> ${part.customer_name}</div>` : ''}
            <table>
              <thead>
                <tr>
                  <th>Nume</th>
                  <th>Cantitate</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
            </table>
          `
        }).join('')

        ordersHtml += `
          <div class="card">
            <div class="section"><b>Comanda:</b> ${order.number} - ${order.id}</div>
            <div class="section"><b>Client:</b> ${order.delivery_details_firstname} | ${order.delivery_details_phone}</div>
            ${order.address_shipping ? `
              <div class="section">
                <b>Adresa:</b>
                ${order.address_shipping.state || ''},
                ${order.address_shipping.city || ''},
                ${order.address_shipping.street || ''} ${order.address_shipping.number || ''},
                ${order.address_shipping.apartment || ''}
                ${order.address_shipping.other_info || ''}
              </div>` : ''}
            ${order.pickup_datetime ? `<div class="section"><b>Data livrare:</b> ${order.pickup_datetime.split(' ')[0]}</div>` : ''}
            ${order.comments && order.comments !== '</br>' ? `<div class="section"><b>Comentarii:</b> ${order.comments}</div>` : ''}
            ${partsHtml}
          </div>
        `
      })

      const content = `
        <html>
          <head>
            <title>Raport Comenzi Livrare</title>
            <style>
              * {
                box-sizing: border-box;
              }
              body {
                font-family: sans-serif;
                padding: 10px;
                margin: 0;
                font-size: 16px;
              }
              .card {
                border: 1px solid #aaa;
                border-radius: 6px;
                padding: 8px;
                margin-bottom: 12px;
                width: 100%;
                page-break-inside: avoid;
              }
              .section {
                margin-bottom: 6px;
              }
             .section b {
                display: inline;
                font-weight: bold;
                margin-right: 4px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 5px;
              }
              th, td {
                border: 1px solid #ccc;
                padding: 2px 4px;
                font-size: 16px;
                word-break: break-word;
              }
              td.center {
                text-align: center;
              }
              .options {
                font-size: 14px;
                color: #555;
              }
            </style>
          </head>
          <body>
            ${ordersHtml}
          </body>
        </html>
      `

      doc.open()
      doc.write(content)
      doc.close()
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    },
    downloadReport () {
      this.loading = true
      const link = document.createElement('a')
      link.href = this.export_file
      link.setAttribute('download', this.export_name)
      document.body.appendChild(link)
      link.click()
      this.$nextTick(() => {
        this.loading = false
      })
    },
    print () {
      if (document.getElementsByClassName('left-vertical-tabs')[0]) {
        document.getElementsByClassName('left-vertical-tabs')[0].classList.add('noprint')
      }
      window.print()
    },
    getData () {
      if (!this.isPdfRaport) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.date[0],
        end_date: this.date[1]
      }
      this.loading = true
      this.apiRequest('/reports/get-pdf', 'GET', data, response => {
        if (response.status === true) {
          this.orders = response.data.orders
          this.products = response.data.products
          this.export_file = response.data.excel.file
          // this.export_name = response.data.excel.file_name
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    test () {
      console.log('test')
    }
  }
}
</script>
<style scoped lang="scss">
  // table {
  //   border-collapse: collapse;
  //   width: 100%;
  // }
  // td, th {
  //   border: 1px solid #dddddd;
  //   text-align: left;
  //   padding: 8px;
  // }
  // tr:nth-child(even) {
  //   background-color: #eee;
  // }
  .picker {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .btn-icon.btn-success {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      margin-left: 20px;
    }
  }
  .orders {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    .order {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      // width: calc(50% - 20px);
      width: 100%;
      padding: 10px;
      margin: 10px;
      &:nth-child(3n) {
        page-break-after: always;
      }
      &:nth-last-child(1) {
        page-break-after: avoid;
      }
      .date,
      .com,
      .client,
      .adress {
        margin-bottom: 10px;
      }
      .orderdet {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-bottom: 10px;
        p {
          margin: 0;
        }
      }
      .parts {
        width: 100%;
        text-align: left;
        .part {
          margin-bottom: 20px;
          .oprions {
            margin-left: 10px;
          }
        }
      }
      .total {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        p {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin: 0;
          margin-bottom: 5px;
        }
      }
    }
  }
  .product {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    // width: calc(50% - 20px);
    width: 100%;
    padding: 10px 10px 10px 10px;
    background: #fff;
    margin: 0px 10px 0 10px;
  }
</style>
<style>
  @media print {
   .no-print { display: none; }
   .full-height-tabs.reports-tabs .right-text-tabs, .full-height-tabs.fidelities-tabs .right-text-tabs {
      width: 100%;
    }
  }
</style>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/PdfRaport.vue